import React from "react";

import { Grid, TextField } from "@material-ui/core";
import { Search } from "@material-ui/icons";

import { GridStyled, LabelStyled } from "../../styles/GlobalStyle";
import Btn from "../buttons/Btn";

const TitleTable = ({
  loading = false,
  labelFilter = "",
  title = "",
  handleFilter,
  inputRef,
  children: Children = <></>,
  additionalFilter: AdditionalFilter = <></>,
}) => {
  return (
    <GridStyled
      container
      alignItems="center"
      justify="space-between"
      height="80px"
      border="solid 1px #e4e4e4"
      border-radius="5"
      style={{
        background: "#f6f6f6",
      }}
      spacing={1}
    >
      <Grid item flex={1}>
        <LabelStyled fontSize="38" color="gray" fontWeight="300">
          {title}
        </LabelStyled>
      </Grid>

      {!!handleFilter && (
        <form onSubmit={handleFilter} style={{ marginRight: 5, flex: 2 }}>
          <Grid
            container
            spacing={1}
            justify="flex-end"
            alignItems="center"
            style={{ gap: "10px", flexWrap: "nowrap" }}
          >
            <TextField
              inputRef={inputRef}
              variant="filled"
              label={labelFilter}
              style={{ minWidth: "32%" }}
            />
            {AdditionalFilter}
            <GridStyled item flex={1} height="65px">
              <Btn disabled={loading} label={<Search />} full type="submit" />
            </GridStyled>
          </Grid>
        </form>
      )}

      {Children}
    </GridStyled>
  );
};

export { TitleTable };
